<template>
  <div class="public">
    <router-view></router-view>
    <ul class="footmenu" v-if="!isHome">
      <li>
        <router-link to="/Index">
          <div class="iconwarp">
            <img slot="icon" src="../assets/menu1.svg" class="def">
            <img slot="icon" src="../assets/menu1-h.svg" class="hid">
          </div>
          <div class="menutext">首页</div>
        </router-link>
      </li>
      <li>
        <router-link to="/collection">
          <div class="iconwarp">
            <img slot="icon" src="../assets/menu2.svg" class="def">
            <img slot="icon" src="../assets/menu2-h.svg" class="hid">
          </div>
          <div class="menutext">藏品</div>
        </router-link>
      </li>
      <li>
        <router-link to="/museum">
          <div class="iconwarp">
            <img slot="icon" src="../assets/menu3.svg" class="def">
            <img slot="icon" src="../assets/menu3-h.svg" class="hid">
          </div>
          <div class="menutext">博物馆</div>
        </router-link>
      </li>
      <li>
        <router-link to="/my">
          <div class="iconwarp">
            <img slot="icon" src="../assets/menu4.svg" class="def">
            <img slot="icon" src="../assets/menu4-h.svg" class="hid">
          </div>
          <div class="menutext">我的</div>
        </router-link>
      </li>
    </ul>

    <!-- 固定的尾部 -->
    <!--	<mt-tabbar  v-model="selected">
        <mt-tab-item id="首页">
          <router-link to="/Index">
            <img slot="icon" src="../assets/logo.png">
            首页
          </router-link>
        </mt-tab-item>


      <router-link to="/collection">
        <mt-tab-item id="藏品">
          <img slot="icon" src="../assets/logo.png">
            藏品
        </mt-tab-item>
      </router-link>

      <router-link to="/museum">
        <mt-tab-item id="博物馆">
          <img slot="icon" src="../assets/logo.png">
            博物馆
        </mt-tab-item>
      </router-link>

      <router-link to="/my">
		  	<mt-tab-item id="我的">
          <img slot="icon" src="../assets/logo.png">
				   	我的
			  </mt-tab-item>
      </router-link>

		</mt-tabbar>-->
    <!-- 固定的回到顶部按钮 -->
    <!--	<div class="back-to-top" @click="gotoup" ref="myback" v-if="visible">
			<i class="fa fa-chevron-up"></i>
		</div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "首页",
      visible: false,
      isHome: true
    }
  },
  watch: {
    '$route': {
      handler(val) {
        this.isHome = val.name == 'Index';
      },
      immediate: true  // 立即执行
    }
  },
  methods: {
    //判断是否显示回到顶部按钮
    goup() {
      let that = this;
      this.visible = false;
      // console.log(document.body.scrollTop)
      if (document.body.scrollTop > 350) {
        that.visible = true;
      }
      else {
        that.visible = false;
      }
    },
    //回到顶部函数
    gotoup() {
      var sheight = document.body.scrollTop = 0; //让页面滚动距离为零
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.goup();
    })
  }
}
</script>

<style lang="scss" scoped="">
.public {
  width: 100%;
  height: 100%;
}

.public .footmenu {
  position: fixed;
  background-color: #fafafa;
  color: #8a869e;
  height: 2.45rem;
  width: 100%;
  bottom: 0;
  z-index: 100;

  display: flex;
  justify-content: space-around;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    padding: 0.2rem 0;

    .iconwarp {
      text-align: center;
      height: 1.3rem;

      img {
        width: 1.2rem;
        height: 1.2rem;
      }
    }

    .menutext {
      text-align: center;
      font-size: 0.5rem;
      color: #8E8E93;
    }

    .hid {
      display: none;
    }
  }

  .router-link-active {
    .iconwarp {
      .def {
        display: none
      }

      .hid {
        display: inline-block;
      }
    }

    .menutext {
      color: #C44D41;
    }
  }
}

/*脚部*/
.public .mint-tabbar {
  position: fixed;
  background-color: #fafafa;
  color: #8a869e;
}

.public .mint-tab-item-label {
  font-size: 1rem;
}

.public .mint-tabbar i {
  display: block;
  margin: 0.2rem 0;
}

.public a {
  display: block;
  text-decoration: none;
  color: inherit;
}

.public a:focus,
a:focus i {
  color: #FE4C40;
}

/*回到顶部*/
.public .back-to-top {
  position: fixed;
  bottom: 16rem;
  right: 0.1rem;
  background: yellow;
  z-index: 2;
  text-align: center;
  color: white;
  background-color: #FE4C40;
  opacity: 0.8;
}

.public .back-to-top i {
  display: block;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/view/common.vue